import React, { useEffect, useMemo } from 'react';
import { useAuth } from '../DataStore/AuthContext';

const RenderSecure = ({ code, children, fallback = null }) => {
  const { getMyPermissions, myPermissions } = useAuth();

  useEffect(() => {
    if (!myPermissions || (Array.isArray(myPermissions) && myPermissions.length === 0)) {
      getMyPermissions();
    }
  }, [myPermissions]);

  const required = useMemo(() => {
    if (!code) return [];
    return Array.isArray(code) ? code : [code];
  }, [code]);

  const hasPermission = useMemo(() => {
    if (!required.length) return false;

    // SUPER user has access to everything
    if (myPermissions === 'SUPER') return true;

    if (!Array.isArray(myPermissions)) return false;

    const keys = myPermissions.map((p) => p.permission_key);
    return required.some((perm) => keys.includes(perm));
  }, [myPermissions, required]);

  return hasPermission ? <>{children}</> : fallback;
};

export default RenderSecure;
